//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet, axiosPost } from '../../axios/axios.js'
import { EventBus } from '../../EventBus/EventBus.js'
import { formatTime } from '../../components/helpers.js'
import { getReturnFilesGroups } from './VehicleIssuance.js'
import { journalRecordFilesGroups } from '../../components/File/JournalRecordFilesGroups.js'

import FilesField from '../../components/File/FilesField.vue'
import ReadonlyDocumentsField from '../../components/File/ReadonlyDocumentsField.vue'
import WaybillCommentsTable from '../Waybill/WaybillComments/WaybillCommentsTable.vue'
import StockInventoryTasksWarning from '../Waybill/StockInventoryTasksWarning.vue'

export default {
  components: {
    ReadonlyDocumentsField,
    FilesField,
    WaybillCommentsTable,
    StockInventoryTasksWarning
  },
  mixins: [journalRecordFilesGroups],
  props: {
    fuelingAct: {
      type: Boolean,
      default: false
    },
    washingAct: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    const filesGroups = getReturnFilesGroups(true)
    const filesGroupsMap = Object.fromEntries(filesGroups.map(filesGroup => [filesGroup.key, filesGroup]))

    return {
      recordId: null,

      record: {
        operationGoals: [],
        vehicle: null,
        operation: null,
        employee: null,
        odometerValue: null,
        odometerValueLastReturn: null,
        odometerManualValue: null,
        fuelVolume: null,
        fuelVolumeLastReturn: null,
        fuelManualVolume: null,
        transportationKindId: null,
        actualVehicleIssuanceReturnRecordId: null
      },

      vehicles: [],
      optionsVehicles: [],

      arrListTransportationKind: [],

      employees: [],
      optionsEmployees: [],

      operations: [],

      operationGoals: [],

      loading: false,

      // === Конфигурация групп файлов
      documentsProperty: 'documentsReturn', // Override - зависит от record.operationType
      documentUploadURL: '/service/delta/journal/vehicleIssuance/upload', // Override
      documentRemoveURL: '/service/delta/journal/vehicleIssuance/deleteFromRecord', // Override
      vehiclePerspectiveFilesGroups: [],

      filesGroups,
      filesGroupsMap,
      // ===
      commentsStart: [],
      commentsClose: [],

      stockInventoryTasks: []
    }
  },
  computed: {
    valid: function () {
      return !!this.vehicleReturn.odometerManualValue && !!this.vehicleReturn.fuelManualVolume && this.validFilesGroups
    }
  },
  watch: {
    'record.vehicle': function (result) {
      if (result) {
        if (!this.fuelingAct && !this.washingAct) {
          if (this.record.vehicle.issued) {
            this.record.operation = 'returnToStock'
          } else {
            this.record.operation = 'giveWithoutWaybill'
          }
        }
        if (this.record.vehicle.notFixedRemarks) {
          this.record.vehicle.notFixedRemarks.forEach(remark => {
            this.$set(remark, 'files', [])
            if (remark.photos) {
              remark.photos.forEach(photo => {
                remark.files.push({
                  name: 'Неустраненное замечание' + '-' + photo.id,
                  id: photo.id
                })
              })
            }
          })
        }
      }

      this.updateStockInventoryTasks()
    },
    'record.operation': {
      handler: function (result) {
        if (result === 'returnToStock' || result === 'giveWithoutWaybill') {
          this.record.transportationKindId = null
        } else {
          this.setTransportationKind()
        }

        if (result === 'giveWithWaybill' || result === 'giveWithoutWaybill') {
          this.documentsProperty = 'documentsDeparture'
          this.record.operationGoals = this.operationGoals.filter(goal => goal.key === 'basicGoal').map(goal => goal.id)
        } else {
          this.documentsProperty = 'documentsReturn'
          this.record.operationGoals = []
        }
      },
      immediate: true
    },
    'record.employee': function () {
      this.updateStockInventoryTasks()
    }
  },
  created: function () {
    if (this.fuelingAct || this.washingAct) {
      this.record.operation = 'giveWithoutWaybill'
      const user = this.$store.getters.getUser
      if (user && user.employee && user.employee.id) {
        this.record.employee = user.employee.id
      }
    }
    this.getEmployees()
    this.getVehicles()
    this.loadOperationsTypes()
    this.getTransportationKind()
    this.getOperationGoals()

    this.prepareFilesGroups()
  },
  methods: {
    // Override
    getRecordId: function () {
      return this.recordId || -1
    },
    // Override
    getFilesPreloadFormId: function () {
      if (!this.recordId && this.record.vehicle) {
        return 'vehicleIssuance_' + this.record.vehicle.id
      }
      return null
    },
    // Override
    prepareFilesGroups: function () {
      this.clearFilesGroups()

      const record = this.record
      const transportAdmin = this.$d_hasRole('transportAdmin', 'admin')

      this.vehiclePerspectiveFilesGroups = []
      this.filesGroups.forEach(filesGroup => {
        const vehiclePerspective = filesGroup.documentType === 'vehiclePerspective'
        if (vehiclePerspective) {
          this.vehiclePerspectiveFilesGroups.push(filesGroup)

          Object.defineProperty(filesGroup.props, 'required', {
            get: function () {
              return record.operation === 'returnToStock' && !!(record.vehicle && record.vehicle.waybillObject) && !transportAdmin
            }
          })
        } else {
          if (filesGroup.documentType === 'vehicleOdometer') {
            filesGroup.props.required = true
          }
        }

        filesGroup.props.collapseId = filesGroup.key + '_collapse'
      })

      // Заполнение
      if (this.getFilesPreloadFormId()) {
        this.$q.loading.show({ spinnerColor: 'blue-11' })
        this.loadPreloadedFiles()
          .finally(() => this.$q.loading.hide())
      } else if (this.record[this.documentsProperty]) {
        this.record[this.documentsProperty].forEach(document => {
          this.pushFile(document)
        })
      }
    },
    onSaveVehicleSelection: function (vehicle) {
      if (vehicle) {
        this.record.odometerValue = vehicle.odometerValue
        this.record.odometerValueLastReturn = null // vehicle.odometerValueLastReturn
        this.record.odometerManualValue = vehicle.odometerValue // vehicle.odometerValueLastReturn

        this.record.fuelVolume = vehicle.fuelValue
        this.record.fuelVolumeLastReturn = null // vehicle.fuelValueLastReturn
        this.record.fuelManualVolume = vehicle.fuelValue // vehicle.fuelValueLastReturn
        this.record.actualVehicleIssuanceReturnRecordId = null
        this.getLastReturn(vehicle.id)

        this.record.notFixedRemarks = vehicle.notFixedRemarks

        if (!this.fuelingAct && !this.washingAct) {
          if (!vehicle.issued) {
            this.record.operation = 'giveWithoutWaybill'
          } else {
            this.record.operation = 'returnToStock'
          }
        }
        const input = this.$refs.vehicle.$refs.target
        if (input) {
          input.blur()
        }
      }
    },
    close: function () {
      if (this.fuelingAct || this.washingAct) {
        this.$emit('close')
      } else {
        if (window.history.length != 1 && window.history.state !== null) {
          this.$router.back()
        } else {
          this.$router.push('/')
        }
      }
    },

    validateRecord: function (strict) {
      const validPhotosMessages = this.getFilesGroupsValidationMessages(strict)
      let valid = validPhotosMessages.length === 0
      if (!valid) {
        let message = ''
        if (validPhotosMessages.length) {
          message += 'Не прикреплены фотографии ' + validPhotosMessages.join(', ') + '.'
        }
        this.$q.notify({
          type: 'negative',
          message: message,
          progress: true,
          timeout: 8000
        })
      }
      if (!this.fuelingAct && !this.washingAct) {
        valid = valid && this.$refs.employee.validate() &&
          this.$refs.operation.validate()
      }
      return valid &&
            this.$refs.vehicle.validate() &&
            this.$refs.odometerValue.validate() &&
            this.$refs.fuelVolume.validate() &&
            (this.$refs.operationGoals ? this.$refs.operationGoals.validate() : true)
    },
    save: function () {
      if (!this.validateRecord()) {
        return
      }
      this.$q.loading.show({ spinnerColor: 'blue-11' })

      this.uploadFiles()
        .then(result => {
          if ((result && result.status !== 'positive') || !this.validateRecord(true)) {
            return Promise.reject(Error())
          }

          const url = 'service/delta/journal/vehicleIssuance/save'

          const documentsIds = []
          this.filesGroups.forEach(filesGroup => {
            documentsIds.push(...filesGroup.files.map(file => file.id))
          })

          const body = {}
          body.vehicleId = this.record.vehicle.id
          if (this.record.employee) {
            body.receiverEmployeeId = this.record.employee
          }
          body.operationType = this.record.operation
          body.notes = this.record.notes
          body.operationGoalsIds = this.record.operationGoals
          body.odometerValue = +this.record.odometerValue
          body.fuelVolume = +this.record.fuelValue
          body.odometerManualValue = +this.record.odometerManualValue
          body.fuelManualVolume = +this.record.fuelManualVolume
          body.transportationKindId = this.record.transportationKindId
          body[this.documentsProperty] = documentsIds

          if (this.fuelingAct || this.washingAct) {
            body.recordStatus = 'accepted'
          }

          const bodyFormData = new FormData()
          bodyFormData.set('properties', JSON.stringify(body))

          return axiosPost({
            url: url,
            data: bodyFormData,
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
            onSuccess: (response) => {
              if (response.data.recordId) {
                if (this.$refs.waybillCommentsClose) {
                  this.$refs.waybillCommentsClose.setCommentsService(response.data.recordId, 'closeVJ', this.commentsClose)
                } else if (this.$refs.waybillCommentsStart) {
                  this.$refs.waybillCommentsStart.setCommentsService(response.data.recordId, 'startVJ', this.commentsStart)
                }
              }
              this.$q.notify({
                type: 'positive',
                message: 'Создана запись журнала',
                progress: true,
                timeout: 3000
              })

              if (this.fuelingAct || this.washingAct) {
                this.$emit('create', this.record)
                this.close()
              } else {
                this.$router.replace('/transport/vehicleIssuance/' + response.data.recordId)
                EventBus.$emit('update-vehicleIssuance', {})
              }
            },
            onFailure: response => Promise.reject(Error(response.message || 'Ошибка сохранения записи журнала')),
            throws: true
          }).finally(() => this.$q.loading.hide())
        })
        .catch(result => {
          if (result.message) {
            this.$q.notify({
              type: 'negative',
              message: result.message,
              progress: true,
              timeout: 8000
            })
          }
        }).finally(() => this.$q.loading.hide())
    },

    filterVehicles (val, update) {
      if (val === '') {
        update(() => {
          this.optionsVehicles = this.vehicles
        })
        return
      }
      update(() => {
        const str = val.toLowerCase()
        this.optionsVehicles = this.vehicles.filter((vehicle) => {
          return vehicle.name && vehicle.name.toLowerCase().indexOf(str) > -1 || vehicle.gosNumber && vehicle.gosNumber.toLowerCase().indexOf(str) > -1
        })
      })
    },
    getVehicles: function () {
      this.$q.loading.show({ spinnerColor: 'blue-11' })
      axiosGet({
        url: 'service/delta/vehicle/list', // '?fields=stockInventoryTasks',
        onSuccess: (response) => {
          this.vehicles = []
          response.data.forEach(element => {
            if (!(element.waybillState == null || (element.waybillState.id && (element.waybillState.id == 'WB3' || element.waybillState.id == 'WB4')))) {
              element.disable = true
            }
            this.vehicles.push(element)
          })
          if (this.fuelingAct || this.washingAct) {
            this.vehicles = this.vehicles.filter(vehicle => {
              return !vehicle.issued
            })
          }
          this.$q.loading.hide()
        },
        onFailure: 'Ошибка загрузки списка доступных транспортных средств',
        msgTarget: this
      })
    },
    updateStockInventoryTasks: function () {
      this.getStockInventoryTasks().then(stockInventoryTasks => {
        if (stockInventoryTasks.length) {
          this.stockInventoryTasks = stockInventoryTasks
        }
      })
    },
    getStockInventoryTasks: function () {
      const record = this.record
      if (!record.vehicle || !record.employee || record.operation !== 'giveWithoutWaybill') {
        return Promise.resolve([])
      }

      const params = new URLSearchParams()
      params.set('vehicle', record.vehicle.id)
      params.set('employee', record.employee)
      // params.set('fromTime', currentTime)
      // params.set('toTime', futureInfinity)

      return axiosGet({
        url: '/service/delta/stockInventory/task/getVehicleTasks?' + params.toString(),
        onSuccess: (response) => response.data.result,
        onFailure: 'Ошибка загрузки заявок на инвентаризацию склада ТС',
        msgTarget: this
      })
    },
    filterEmployees (val, update) {
      if (val === '') {
        update(() => {
          this.optionsEmployees = this.employees
        })
        return
      }
      update(() => {
        const str = val.toLowerCase()
        this.optionsEmployees = this.employees.filter((employee) => {
          return employee.name.toLowerCase().indexOf(str) > -1
        })
      })
    },
    getEmployees: function () {
      this.$q.loading.show({ spinnerColor: 'blue-11' })
      axiosGet({
        url: '/service/delta/employee/search?state=work&fields=stockInventoryTasks',
        onSuccess: (response) => {
          this.employees = response.data.result
          this.employees = this.employees.filter(employee => {
            return employee.canBeDriver
          })
          this.$q.loading.hide()
        },
        onFailure: 'Ошибка загрузки списка сотрудников',
        msgTarget: this
      }).finally(() => this.$q.loading.hide())
    },
    formatDataFromUnixTime: function (unixTime) {
      if (unixTime) {
        return formatTime(unixTime)
      } else {
        return 'Нет данных'
      }
    },
    loadOperationsTypes: function () {
      this.loading = true
      axiosGet({
        url: 'service/delta/journal/vehicleIssuance/getOperationTypes',
        onSuccess: response => {
          this.operations = Object.entries(response.data.result).map(entry => {
            return { value: entry[0], name: entry[1] }
          })

          // Только "Выдача ТС без оформления путевого листа" и "Сдача ТС в гараж"
          this.operations = this.operations.filter(operation => operation.value === 'giveWithoutWaybill' || operation.value === 'returnToStock')
        },
        onFailure: 'Ошибка загрузки типов операций'
      })
        .finally(() => {
          this.loading = false
        })
    },
    getTransportationKind: function () {
      this.loading = true
      return axiosGet({
        url: '/service/obj/search?nameField=name&type=transportationKind',
        onSuccess: (response) => {
          this.arrListTransportationKind = response.data.result
          return Promise.resolve()
        },
        onFailure: 'Ошибка получения справочника вида перевозок',
        msgTarget: this
      })
        .finally(() => {
          this.loading = false
        })
    },
    getOperationGoals: function () {
      this.loading = true
      axiosGet({
        url: '/service/obj/search?nameField=name&type=vehicleIssuanceGoal',
        onSuccess: (response) => {
          this.operationGoals = response.data.result
        },
        onFailure: 'Ошибка загрузки целей выдачи',
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    },
    setTransportationKind: function () {
      if (!this.record.transportationKindId) {
        const transportationKind = this.arrListTransportationKind.find(element => element.name === 'Перевозки в городском сообщении, в служебных целях')
        if (transportationKind) {
          this.record.transportationKindId = transportationKind.id
        }
      }
    },
    onEnter: function () {
      this.$refs.vehicle.$el.focus()
    },
    updateWaybillComments: function (val) {
      this.$nextTick(() => {
        switch (val.type) {
          case 'closeVJ':
            this.commentsClose = val.commentsList
            break
          case 'startVJ':
            this.commentsStart = val.commentsList
            break
          default:
            break
        }
      })
    },
    updateAfterAddComments: function (lstComments) {
      this.$nextTick(() => {
        if (lstComments.type == 'startVJ') {
          this.commentsStart = lstComments.comments.comments || []
        } else if (lstComments.type == 'closeVJ') {
          this.commentsClose = lstComments.comments.comments || []
        }
      })
    },
    getLastReturn: function (id) {
      this.loading = true
      return axiosGet({
        url: '/service/delta/vehicle/get?id=' + id + '&includeIssuanceData=true',
        onSuccess: (response) => {
          this.record.actualVehicleIssuanceReturnRecordId = response.data.actualVehicleIssuanceReturnRecordId
        },
        onFailure: 'Ошибка получения ID последнего закрытого рейса',
        throws: true
      })
        .then(() => {
          this.getDataLastReturn()
        })
        .finally(() => {
          this.loading = false
        })
    },
    getDataLastReturn: function () {
      if (this.record.actualVehicleIssuanceReturnRecordId) {
        return axiosGet({
          url: '/service/delta/journal/vehicleIssuance/get?id=' + this.record.actualVehicleIssuanceReturnRecordId,
          onSuccess: (response) => {
            const result = response.data.result
            this.record.odometerValueLastReturn = result.odometerManualValue
            if (result.odometerManualValue) {
              this.record.odometerManualValue = result.odometerManualValue
            }

            this.record.fuelVolumeLastReturn = this.formatRealRound(result.fuelManualVolume)
            if (result.fuelManualVolume) {
              this.record.fuelManualVolume = this.formatRealRound(result.fuelManualVolume)
            }
          },
          onFailure: 'Ошибка загрузки данных из последнего закрытого рейса'
        })
      }
      return Promise.resolve()
    },
    formatRealRound: function (value) {
      return (value == 0 || value) ? (Math.round(parseFloat(value) * 100) / 100) : null
    }
  }
}

